const transformReactCodeToJSON = (input) => {
    const regex = /<FinishedWork\s+title='([^']*)'\s+number='([^']*)'\s+date={translations\[language\]\["(.*?)"\]}\s+pdfURL='([^']*)'\s+imgName='([^']*)'(?:\s+content='([^']*)')?\s*\/>/g;

    const matches = input.matchAll(regex);

    const result = [];

    for (const match of matches) {
        const [, title, number, date, pdfURL, imgName, content] = match;

        const data = {
            title,
            number,
            date,
            pdfURL,
            imgName,
        };

        if (content) {
            data.content = content;
        }

        result.push(data);
    }

    return JSON.stringify(result, null, 2);
};

export default transformReactCodeToJSON;